import React, { FC, PropsWithChildren } from 'react';

type MagnifyingGlassProps = {
  /** The color of the icon. */
  color?: string;
};

const MagnifyingGlass: FC<PropsWithChildren<MagnifyingGlassProps>> = ({ color = 'currentColor' }) => (
  <svg fill="none" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M0 7.5C0 3.4 3.4 0 7.5 0S15 3.4 15 7.5 11.6 15 7.5 15 0 11.6 0 7.5zm13 0c0-3-2.5-5.5-5.5-5.5S2 4.5 2 7.5 4.5 13 7.5 13 13 10.5 13 7.5z"
      fill={color}
      fillRule="evenodd"
    />
    <path d="M13.44 13.44a1.5 1.5 0 000 2.12l4 4a1.5 1.5 0 002.12-2.12l-4-4a1.5 1.5 0 00-2.12 0z" fill={color} />
  </svg>
);

export default MagnifyingGlass;
